
export function generateRandomHtmlId() {
    return "_" + Math.random().toString(36).substring(2, 9);
}

export function setCookie(key, value, hours) {
    // Source:
    // https://stackoverflow.com/a/24103596
    let expires = "";
    if (hours) {
        let date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    let encodedValue = encodeURIComponent(value);
    document.cookie = key + "=" + (encodedValue || "") + expires + "; path=/";
}

export function deleteCookie(key) {
    if (document.cookie.trim() == "") return;
    let cookieKeyValPairs = document.cookie.split(";");
    let cookieStr = "";
    for (let i = 0; i < cookieKeyValPairs.length; ++i) {
        let [k, v] = cookieKeyValPairs[i].split("=");
        if (cookieStr) cookieStr += ";";
        cookieStr += k + "=" + v;
        if (key === k.trim()) {
            // You don't delete a cookie, you set its expiration to a past date
            cookieStr += "; expires=Thu, 01 Jan 1970 00:00:00; path=/"
        }
    }
    document.cookie = cookieStr;
}
